import axios from '../api'
import trackingAxios from '../trackingApi'

export default {
/**
 * 获取验证码
 */
  getVCode: data => {
    return axios({
      url: '/protected/sms/get_sms_vcode',
      method: 'post',
      data
    })
  },
  /**
   * 验证验证码
   */
  validVCode: data => {
    return axios({
      url: '/protected/sms/valid_sms_vcode',
      method: 'post',
      data
    })
  },
  /**
   * web登录
   */
  webLogin: data => {
    return axios({
      url: '/protected/web_login',
      method: 'post',
      data
    })
  },
  /**
   * 获取门店列表
   */
  getUserCustomers: (data, cancelToken) => {
    return axios({
      url: '/protected/curr_user_customers',
      method: 'post',
      data,
      cancelToken
    })
  },
  /**
   * 登出
   */
  logoutOut: () => {
    return axios({
      url: '/protected/dcp_login_out',
      method: 'get'
    })
  },
  /**
   * 设置新密码
   */
  setNewPass: data => {
    return axios({
      url: '/protected/dcp_set_new_password',
      method: 'post',
      data
    })
  },
  /**
   * 修改密码
   */
  modifyPassword: data => {
    return axios({
      url: '/protected/password_modify',
      method: 'post',
      data
    })
  },
  /**
   * 获取门店信息
   */
  getCustomerApps: customerNumber => {
    return axios({
      url: `/protected/get_customer_apps/${customerNumber}`,
      method: 'get'
    })
  },
  /**
   * 检查token
   */
  checkToken: data => {
    return axios({
      url: '/protected/check_token',
      method: 'post',
      data
    })
  },
  /**
   * 隐私授权
   */
  signAgreement: data => {
    return axios({
      url: `protected/signAgreement/${data}`,
      method: 'post'
    })
  },
  /**
   * 埋点
   */
  dataTracking: data => {
    return trackingAxios({
      url: '/dcp-sso-api/api/protected/record/save',
      method: 'post',
      data
    })
  }
}
